import { getToken, removeToken, setToken } from '@/helpers/auth'
import userService from '@/services/userService'

const state = {
  token: getToken(),
  userInfo: {},
  isLogin: false,
  emailHash: '',
  tutorialCompleted: undefined
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_LOGIN: (state, status) => {
    state.isLogin = status
  },
  SET_USER_INFO: (state, userData) => {
    state.userInfo = userData
    state.emailHash = userData.email_hash
    state.tutorialCompleted = userData.tutorial_completed
  },
  SET_TUTORIAL_COMPLETED: (state, status) => {
    state.tutorialCompleted = status
  }
}

const actions = {
  login({ commit }, userInfo) {
    return new Promise((resolve, reject) => {
      const { email, password } = userInfo
      userService.login({
        'email': email.trim(),
        password
      }).then((response) => {
        commit('SET_TOKEN', response.token)
        commit('SET_LOGIN', true)
        commit('SET_USER_INFO', response.user)
        setToken(response.token)
        window.dataLayer?.push({
          userId: response.user.id
        })
        resolve(response)
      })
        .catch(error => {
          reject(error)
        })
    })
  },

  // get user info
  getInfo({ commit, state, dispatch }) {
    return new Promise(resolve => {
      userService.getInfo().then((res) => {
        commit('SET_LOGIN', true)
        commit('SET_USER_INFO', res.user)
        window.dataLayer?.push({
          userId: res.user.id
        })
        resolve(true)
      }).catch(() => {
        dispatch('logout')
        resolve(false)
      })
    })
  },

  setTutorialCompleted({ commit }, status) {
    commit('SET_TUTORIAL_COMPLETED', status)
  },

  // user logout
  logout({ commit, state, dispatch }) {
    commit('SET_TOKEN', '')
    commit('SET_LOGIN', false)
    commit('SET_USER_INFO', {})
    removeToken()
  },
  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('SET_ROLES', [])
      removeToken()
      resolve()
    })
  }

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
